import { GetTravelSegmentsResponse } from '@orbit/api-types'
import api from '@lib/api'
import { useQuery } from '@tanstack/react-query'

export const useTravelSegments = (tripId: string | undefined) => {
	return useQuery<GetTravelSegmentsResponse>({
		queryKey: ['travel-segments', tripId],
		queryFn: async () => {
			if (!tripId) {
				throw new Error('Trip ID is required')
			}
			const response = await api.get<GetTravelSegmentsResponse>(
				`/trips/${tripId}/travelSegments`,
			)
			return response.data
		},
		enabled: !!tripId,
		retry: 1,
	})
}
